'use client';

import { Fingerprint, Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function PasskeySetup({
  onRegister,
  loading,
}: {
  onRegister: () => void;
  loading?: boolean;
}) {
  return (
    <div className="cs-card flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <p className="cs-body font-semibold">Skip the typing next time</p>
        <p className="cs-caption mt-0.5 text-[var(--cs-text-secondary)]">
          Save a passkey and this device recognises you instantly.
        </p>
      </div>
      <Button
        type="button"
        variant="outline"
        className="cs-focusable min-h-[var(--cs-touch-min)] shrink-0"
        disabled={loading}
        onClick={onRegister}
      >
        {loading ? (
          <Loader2 className="mr-1.5 size-4 animate-spin" />
        ) : (
          <Fingerprint className="mr-1.5 size-4" aria-hidden="true" />
        )}
        Set up a passkey
      </Button>
    </div>
  );
}
